import {QueryClientProvider} from "@tanstack/react-query";
import "leaflet/dist/leaflet.css";
import React from "react";
import ReactDOM from "react-dom/client";
import {HashRouter as Router} from "react-router-dom";
import {registerSW} from "virtual:pwa-register";

import "./modules/core/i18n";

import {requestImmediateVersionCheck} from "./modules/core/lib/app-update-checker";
import {stripDeployQueryParam} from "./modules/core/lib/force-deploy-reload";
import {initGlitchTip} from "./modules/core/lib/glitchtip";
import {queryClient} from "./modules/core/lib/query-client";

import App from "./components/app";
import "./index.css";

initGlitchTip();
stripDeployQueryParam();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Router future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Router>,
);

if ("serviceWorker" in navigator) {
  // Deploy refresh is driven by version.json (useNewVersion), not controllerchange.
  // With route splitting the SW precaches 100+ chunks; waiting for controllerchange
  // blocked refresh for minutes. Page reload picks up new hashed assets immediately.

  registerSW({
    immediate: true,
    onNeedRefresh() {
      requestImmediateVersionCheck();
    },
    onRegistered(registration) {
      if (!registration) {
        return;
      }
      registration.addEventListener("updatefound", () => {
        requestImmediateVersionCheck();
      });
    },
  });
}
